import { keyToActionTypes } from 'src/utils/keyToActionTypes';

export const dataActionTypes: any = keyToActionTypes(
  {
    GET_FIRST_FETCH: null,
    DATA_FETCHED: null,
    GET_TOTAL_COUNT: null,
    LOAD_MORE: null,
    SELECT_ROW: null,
    SORT_TABLE: null,
    RESET_DATA: null,
  },
  'NOISEEVENTS'
);

export const filterActionTypes: any = keyToActionTypes(
  {
    UPDATE_DATE_RANGE: null,
    UPDATE_SELECTED_ITEMS: null,
    CLEAR_SELECTED_ITEMS: null,
    UPDATE_RANGE_FILTER: null,
    INITIALISE_STORE: null,
  },
  'NOISEEVENTS'
);
